import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Row, Col, Avatar, Spin } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const StripeAlert = ({ loading }: { loading: boolean }) => {
  return (
    <StyledAlert
      type='info'
      message={
        <Row className='_mb-0' justify='space-between' align='middle'>
          {(loading && <Spin />) || (
            <Col span={24}>
              <Span>
                To complete your setup and start transacting, please enter your
                payment details{' '}
                <strong>
                  <StyledLink
                    to='/settings/accounts-and-billing'
                    className='_link-primary banner-link'
                  >
                    here
                  </StyledLink>
                </strong>
              </Span>
            </Col>
          )}
        </Row>
      }
      showIcon
      icon={
        <StyledAvatar icon={<StyledWarningIcon className='warning-icon' />} />
      }
      closable={false}
      banner
    />
  )
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

const StyledAlert = styled(Alert)`
  &.ant-alert {
    position: fixed;
    top: 16px;
    right: 24px;
    z-index: 100;
    background-color: #4a4a68;
    width: 100%;
    max-width: 440px;
    border-radius: 4px;
    padding: 12px;
    animation: ${fadeIn} 250ms ease-in forwards;

    .ant-alert-message {
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;

      > div > div:first-of-type {
        max-width: 40ch;
        line-height: 140%;
      }
    }
  }
`

const StyledAvatar = styled(Avatar)`
  &.ant-avatar {
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #d092dd;
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }
`

const StyledWarningIcon = styled(WarningOutlined)`
  &.warning-icon {
    position: relative;
    bottom: 1px;

    > svg {
      width: 18px;
      height: 18px;

      > path {
        fill: white;
      }
    }
  }
`

const StyledLink = styled(Link)`
  &.banner-link {
    font-weight: 500;
    color: #d092dd;
    text-decoration: underline;
    line-height: 120%;
  }
`

const Span = styled.span`
  font-size: 14px;
`

export default StripeAlert
